import React from "react";
import PropTypes from "prop-types";

import styles from "./CaseInfoCard.module.css";

export function CaseInfoCard({ caseInfo }) {
  return (
    <div className={styles.container}>
      <div className={styles.title}>Case Info</div>

      <div className={styles.hr} />

      <div className={styles.content}>
        <div className={styles.spacer}>
          <div className={styles.title}>Status</div>
          <div>{caseInfo.status}</div>
        </div>
        <div>
          <div className={styles.title}>Incident Type</div>
          <div>{caseInfo.problemType}</div>
        </div>
        <div>
          <div className={styles.title}>Case Owner</div>
          <div>{caseInfo.owner}</div>
        </div>
        <div>
          <div className={styles.title}>Date Created</div>
          <div>{caseInfo.createdAt}</div>
        </div>
        <div>
          <div className={styles.title}>Severity</div>
          <div>{caseInfo.severity}</div>
        </div>
      </div>
    </div>
  );
}

CaseInfoCard.propTypes = {
  caseInfo: PropTypes.object,
};
